export function isServiceVisible(service: { sku?: string; name?: string }) {
    const isManNow = service.sku?.toUpperCase() === 'MAN-SKU00000026' || service.name === 'MAN NOW';

    return !isManNow;
}
